<template>
  <div>
    <router-link
      v-for="chat in chats" :key="chat.id"
      :to="{ name: 'app-chat', query: { id: window.btoa(chat.id) } }"
      :class="$style.item"
      @click.native="hideModal"
    >
      <AvatarGroup
        :chat="chat"
        :size="44"
      />
      <div :class="$style.name">{{ chat.name }}</div>
    </router-link>
  </div>
</template>

<script>
import Chat from '@/models/Chat'
import Participant from '@/models/Participant'
import AvatarGroup from '@/components/AvatarGroup'
import { mapGetters } from 'vuex'

export default {
  name: 'profile-shared-groups',
  components: {
    AvatarGroup
  },
  props: {
    chat: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    chatWithParticipants () {
      return Chat.query().whereId(this.chat.id).with('participants').first()
    },
    participants () {
      return this.chatWithParticipants.participants
    },
    receiverId () {
      return this.chatWithParticipants.participants.find(participant => participant.userId !== this.user.id).userId
    },
    chats () {
      const receiverParticipants = Participant.query()
        .where('userId', this.receiverId)
        .get()
      const chatIds = receiverParticipants.map(part => part.chatId)
      return Chat
        .query()
        .whereIdIn(chatIds)
        .where(chat => chat.typeName === 'group')
        .get()
    }
  },
  methods: {
    hideModal () {
      this.$modal.hide('profile')
    }
  }
}
</script>

<style module lang="scss">
.item {
  display: flex;
  padding: 10px 20px;
  align-items: center;
  &:not(:first-child) {
    border-top: 1px solid $border-color;
  }
  &:hover {
    background-color: rgba($main-bg-darkest, 0.1);
  }
}
.name {
  font-size: 16px;
  margin-left: 16px;
  font-weight: 500;
  color: $text-darkest;
}
</style>
